// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/bilateral_blur.fragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'bilateral_blurPixelShader';
const shader = `#ifdef GL_ES
#endif
precision highp float;
varying vec2 vUV;
uniform sampler2D depthSampler;
uniform sampler2D textureSampler;
uniform vec2 direction;
uniform float depthThreshold;
#ifdef ENABLE_NORMAL_FILTERING
uniform sampler2D normalSampler;
uniform float normalCosineThreshold;
#endif
#ifdef ENABLE_NORMAL_FILTERING
vec3 getNormal(ivec2 uv) {
vec3 normal;
normal.xy = texelFetch(normalSampler, uv, 0).rg * 2.0 - 1.0;
normal.z = sqrt(max(0.0, 1.0 - dot(normal.xy, normal.xy)));
return normal;
}
#endif
void main(void)
{
float sourceDepth = texelFetch(depthSampler, ivec2(gl_FragCoord.xy), 0).r;
float result = texelFetch(textureSampler, ivec2(gl_FragCoord.xy), 0).r;
float weightSum = 1.0;
float effectiveDepthThreshold = depthThreshold;
#ifdef ENABLE_NORMAL_FILTERING
vec3 sourceNormal = getNormal(ivec2(gl_FragCoord.xy));
effectiveDepthThreshold /= abs(sourceNormal.z);
#endif
#ifndef PASSTHROUGH
for(float x = -1.0; x >= -RADIUS; x -= 1.0) {
vec2 uv = gl_FragCoord.xy + direction * x;
float depth = texelFetch(depthSampler, ivec2(uv), 0).r;
float value = texelFetch(textureSampler, ivec2(uv), 0).r;
#ifdef ENABLE_NORMAL_FILTERING
vec3 normal = getNormal(ivec2(uv));
if (abs(depth - sourceDepth) < effectiveDepthThreshold && dot(sourceNormal, normal) > normalCosineThreshold)
#else
if (abs(depth - sourceDepth) < effectiveDepthThreshold)
#endif
{
float w = 1.0;
result += value * w;
weightSum += w;
}
}
for(float x = 1.0; x <= RADIUS; x += 1.0) {
vec2 uv = gl_FragCoord.xy + direction * x;
float depth = texelFetch(depthSampler, ivec2(uv), 0).r;
float value = texelFetch(textureSampler, ivec2(uv), 0).r;
#ifdef ENABLE_NORMAL_FILTERING
vec3 normal = getNormal(ivec2(uv));
if (abs(depth - sourceDepth) < effectiveDepthThreshold && dot(sourceNormal, normal) > normalCosineThreshold)
#else
if (abs(depth - sourceDepth) < effectiveDepthThreshold)
#endif
{
float w = 1.0;
result += value * w;
weightSum += w;
}
}
#endif
gl_FragColor = vec4(result / weightSum, 0, 0, 1);
}
`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const bilateral_blurPixelShader = { name, shader };
//# sourceMappingURL=bilateral_blur.fragment.js.map